/* eslint-disable @typescript-eslint/ban-types */import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseInput } from "@/components/common/BaseInputV2";
import styles from "./index.module.scss";
import { NewBaseButton } from "@/components/common/NewBaseButton";
import { useEffect, useRef, useState } from "react";
import { RegisterApi } from "@/service/register";
import classNames from "classnames";
import { registerFormPost } from "../../util";
import { usePopups } from "@/store/popups";
import { useUserCreate } from "@/store/User";
import ToastV2 from "@/components/common/BaseToast";
import { useTranslations } from "next-intl";
export const GLOBAL_COUNTDOWN = 60;
export const VerifyPage = props => {
  const {
    data,
    changeAccountData
  } = props;
  const [restTime, setRestTime] = useState(0);
  const timerRef = useRef(null);
  const popupDispatch = usePopups(state => state.dispatch);
  const userDispatch = useUserCreate(state => state.dispatch);
  const t = useTranslations();
  useEffect(() => {
    resendVerify();
  }, []);
  const resendVerify = () => {
    if (timerRef.current || !data.email) return;
    setRestTime(GLOBAL_COUNTDOWN);
    setTimeout(() => {
      setIntervalTimeHandle();
    }, 0);
    RegisterApi.getEmailVerify(data.email, "register").then(res => {
      if (res.code === 0) {
        return;
      } else {
        timerRef.current && clearInterval(timerRef.current);
        timerRef.current = null;
        setRestTime(0);
        ToastV2.info(res.msg);
      }
    });
  };
  const setIntervalTimeHandle = () => {
    timerRef.current = setInterval(() => {
      setRestTime(prev => {
        if (prev <= 0 && timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          return prev;
        } else {
          return prev - 1;
        }
      });
    }, 1000);
  };
  const SendCode = () => {
    return /*#__PURE__*/_jsx("span", {
      className: classNames({
        [styles.resend_btn]: true,
        [styles.rest_num]: restTime > 0
      }),
      onClick: resendVerify,
      children: restTime == 0 ? "Send Code" : "".concat(restTime, "s")
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.verify_container,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.title,
      children: t("Login_Verify_Page_Title")
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.desc,
      children: [/*#__PURE__*/_jsx("span", {
        children: t("Login_Verify_Page_Desc")
      }), /*#__PURE__*/_jsx("span", {
        className: styles.email,
        children: data.email
      }), /*#__PURE__*/_jsx("span", {
        children: t("Login_Verify_Page_Desc2")
      })]
    }), /*#__PURE__*/_jsx(BaseInput, {
      className: styles.verify_input,
      onChange: e => {
        changeAccountData({
          code: e.target.value
        });
      },
      value: data.code,
      placeholder: t("Login_ActivationCode_Placeholder"),
      suffix: /*#__PURE__*/_jsx(SendCode, {})
    }), /*#__PURE__*/_jsx(NewBaseButton, {
      className: styles.log_btn,
      size: "medium",
      block: true,
      disabled: !data.code,
      onClick: () => {
        registerFormPost(data, popupDispatch, userDispatch, props.onSucc);
      },
      children: t("Login_Verify_Code")
    })]
  });
};